export type InvitationColorPalette = {
    color1?: string
    color2?: string
    color3?: string

}

export const invitationColorPaletteMap = new Map<string, InvitationColorPalette>([
    ['yellow-white', {
        color1: "white",
        color2: "#f1b814",
        color3: "white",
    }],
    ['dark-green', {
        color1: "rgba(0, 66, 64)",
        color2: "rgba(0, 66, 64, 0.6)",
        color3: "rgba(0, 66, 64, 0.4)",
    }],

    ['red-black-yellow', {
        color1: "#bd1e51",
        color2: "#490b3d",
        color3: "#f1b814"
    }],
    ['default', {
        color1: "#490b3d",
        color2: "#490b3d",
        color3: "#490b3d",
    }],
    ['red', {
        color1: "#ff0000",
        color2: "#b30000",
        color3: "#ffcccc",
    }],
    ['green', {
        color1: "#00ff00",
        color2: "#008000",
        color3: "#ccffcc",
    }],
    ['blue', {
        color1: "#0074d9",
        color2: "#001f3f",
        color3: "#cce6ff",
    }],
    ['yellow', {
        color1: "#ffff00",
        color2: "#f1c40f",
        color3: "#fff9cc",
    }],
    ['black', {
        color1: "#000000",
        color2: "#222222",
        color3: "#444444",
    }],
    ['white', {
        color1: "#ffffff",
        color2: "#f8f8f8",
        color3: "#e0e0e0",
    }],
    ['gray', {
        color1: "#808080",
        color2: "#d3d3d3",
        color3: "#f0f0f0",
    }],

])
